'use strict';

var _ = require('lodash');
var GridFaresSaveButtonDirective = function GridFaresSaveButtonDirective() {
  return {
    restrict: 'E',
    require: '^^rmGridToolbar',
    scope: true,
    template: require('../templates/grid-fares-save-button.html'),
    controller: 'GridFaresSaveButtonController',
    link: function link($scope) {
      $scope.$on('keyboard:save', function (ev) {
        if (!$scope.screenState.isFBCodeGridVisible || $scope.screenState.isFBCodeGridVisible && _.get($scope.screenState, 'averageFaresGridState.selectedFlowType') === 'MAPPED') {
          $scope.saveChanges();
        }
        ev.preventDefault();
        return false;
      });
    }
  };
};
GridFaresSaveButtonDirective.$inject = [];
module.exports = GridFaresSaveButtonDirective;